import http from "src/services/http";
import * as types from "src/store/types/configuracoes";
import store from "..";

export const carregarConfiguracoes = () => {
  return (dispatch) => {
    dispatch({ type: types.CONF_LOADING, payload: true });
    http.get("/api/v2/empresa/configuracoes").then(
      (resp) => {
        dispatch([
          { type: types.CONF_SET_CONFIGURACOES, payload: resp.data },
          { type: types.CONF_LOADING, payload: false },
        ]);
      },
      (error) => {
        dispatch([{ type: types.CONF_LOADING, payload: false }]);
      }
    );
  };
};

export const salvarEmpresa = ({ loading = false }) => {
  const {
    configuracoes: {
      id,
      nome,
      cpf_cnpj,
      endereco,
      numero,
      complemento,
      cep,
      cidade,
      uf,
      telefone,
      celular,
      email,
    },
  } = store.getState().configuracoes;
  store.dispatch({ type: types.CONF_LOADING, payload: loading });
  return new Promise((resolve, reject) => {
    http
      .put(`/api/v2/empresa/${id}`, {
        nome,
        cpf_cnpj,
        endereco,
        numero,
        complemento,
        cep,
        cidade,
        uf,
        telefone,
        celular,
        email,
      })
      .then(
        (_) => resolve(),
        (e) => reject(e)
      );
  });
};

export const salvarConfiguracoes = ({ loading = false }) => {
  const {
    configuracoes: {
      nome_fantasia,
      qtd_maximo,
      valor_maximo,
      cashback,
      dias_vencto_cashback,
      descricao_empresa,
      horario_funcionamento,
    },
  } = store.getState().configuracoes;
  store.dispatch({ type: types.CONF_LOADING, payload: loading });
  return new Promise((resolve, reject) => {
    http
      .put(`api/v2/empresa/configuracoes/${nome_fantasia}}`, {
        nome_fantasia,
        qtd_maximo,
        valor_maximo,
        cashback,
        dias_vencto_cashback,
        descricao_empresa,
        horario_funcionamento,
      })
      .then(
        (_) => resolve(),
        (e) => reject(e)
      );
  });
};

export const uploadLogoEmpresa = (base64) => {
  store.dispatch({ type: types.CONF_LOADING, payload: true });
  return http.put("/api/v2/empresa/image/logo", { file: base64 }).then(
    () => {
      store.dispatch({ type: types.CONF_LOADING, payload: false });
    },
    (error) => {
      store.dispatch({ type: types.CONF_LOADING, payload: false });
    }
  );
};
